import React, { useEffect, useState } from "react";
export default function CostIndex() {
  return (
    <>
<div className="Cost w-[1440px] h-[2578px] relative bg-neutral-800">
  <div className="WhatYouStandToGain left-[458px] top-[964px] absolute text-[48px] font-normal">What you stand to gain </div>
  <div className="Frame34785 left-[100px] top-[1108px] absolute justify-start items-center gap-10 inline-flex">
    <div className="Group8641 w-[87px] h-[69px] relative">
      <div className="Group8640 w-[51px] h-[50px] left-[24px] top-[13px] absolute">
        <div className=" left-[31px] top-[2px] absolute text-slate-900 text-[40px] font-bold">1</div>
        <div className=" left-0 top-0 absolute text-slate-900 text-[40px] font-bold">0</div>
      </div>
    </div>
    <div className="Frame34783 justify-center items-center gap-4 flex">
      <div className="ObtainingTheBestPriceForBusinessPurchasesStandardizingAndSimplifyingCostingTechnologies text-white text-[24px] font-medium">Obtaining the best price for business purchases<br/>Standardizing and simplifying costing technologies</div>
    </div>
  </div>
  <div className="Frame34786 left-[100px] top-[1274px] absolute justify-start items-center gap-12 inline-flex">
    <div className="Group8642 w-[87px] h-[69px] relative">
      <div className="Group8640 w-[55px] h-[50px] left-[24px] top-[13px] absolute">
        <div className=" left-[29px] top-[2px] absolute text-slate-900 text-[40px] font-bold">2</div>
        <div className=" left-0 top-0 absolute text-slate-900 text-[40px] font-bold">0</div>
      </div>
    </div>
    <div className="Frame34784 justify-center items-center gap-[9px] flex">
      <div className="AutomatingAndDigitizingItAndBusinessOperationsForCostSavings text-white text-[24px] font-medium">Automating and digitizing IT and business operations for<br/> cost savings.</div>
    </div>
  </div>
  <div className="Frame34795 left-[-258px] top-[1729px] absolute flex-col justify-center items-center gap-14 inline-flex">
    <div className="Frame34793 flex-col justify-center items-center gap-4 flex">
      <div className="Customers text-[18px] font-normal">CUSTOMERS</div>
      <div className="BrandsWeVeWorkedWith text-white text-[32px] font-normal">BRANDS WE’VE WORKED WITH</div>
    </div>
    <div className="Frame34794 justify-start items-center gap-16 inline-flex">
      <div className="SimpleIconsUber w-[156px] h-[156px] py-[51.80px] justify-center items-center flex" />
      <div className="LogosGoogle w-56 h-[73.50px] relative" />
      <div className="CibApplePay w-[148px] h-[148px] pl-[0.02px] pt-[43.17px] pb-[43.38px] justify-center items-center flex" />
      <div className="SimpleIconsAmazonaws w-[124px] h-[124px] relative" />
      <div className="SimpleIconsUber w-[140px] h-[140px] py-[46.49px] justify-center items-center flex" />
      <div className="LogosGoogle w-56 h-[73.50px] relative" />
      <div className="CibApplePay w-[148px] h-[148px] pl-[0.02px] pt-[43.17px] pb-[43.38px] justify-center items-center flex" />
      <div className="SimpleIconsUber w-[140px] h-[140px] py-[46.49px] justify-center items-center flex" />
      <div className="SimpleIconsUber w-[140px] h-[140px] py-[46.49px] justify-center items-center flex" />
    </div>
  </div>
  <div className="Desktop17 w-[1440px] h-[292px] left-0 top-[2286px] absolute bg-neutral-800">
    <div className="Frame34791 left-[100px] top-[64px] absolute flex-col justify-start items-start gap-11 inline-flex">
      <div className="Logo text-white text-[32px] font-medium">LOGO</div>
      <div className="Frame34790 flex-col justify-center items-start gap-4 flex">
        <div className="Frame34789 justify-start items-start gap-2.5 inline-flex">
          <div className="Group8639 w-7 h-7 relative">
            <div className="Ellipse2 w-7 h-7 left-0 top-0 absolute bg-gradient-to-r from-pink-400 to-indigo-500 rounded-full" />
            <div className="RiTwitterFill w-4 h-4 left-[6px] top-[6px] absolute" />
          </div>
          <div className="Group8640 w-7 h-7 relative">
            <div className="Ellipse2 w-7 h-7 left-0 top-0 absolute bg-gradient-to-r from-pink-400 to-indigo-500 rounded-full" />
            <div className="GgFacebook w-4 h-4 left-[6px] top-[7px] absolute" />
          </div>
          <div className="Group8641 w-7 h-7 relative">
            <div className="Ellipse2 w-7 h-7 left-0 top-0 absolute bg-gradient-to-r from-pink-400 to-indigo-500 rounded-full" />
            <div className="BxlInstagramAlt w-4 h-4 left-[6px] top-[6px] absolute" />
          </div>
          <div className="Group8642 w-7 h-7 relative">
            <div className="Ellipse2 w-7 h-7 left-0 top-0 absolute bg-gradient-to-r from-pink-400 to-indigo-500 rounded-full" />
            <div className="TypcnSocialLinkedin w-4 h-4 left-[6px] top-[6px] absolute" />
          </div>
        </div>
        <div className="Frame34781 justify-start items-center gap-2 inline-flex">
          <div className="IconParkOutlineHandleC w-4 h-4 relative">
            <div className="Group w-[13.33px] h-[13.33px] left-[1.33px] top-[1.33px] absolute">
            </div>
          </div>
          <div className="MelodyAiAllRightsReserved text-white text-[12px] font-normal">2022 Melody AI.  All rights reserved</div>
        </div>
      </div>
    </div>
    <div className="Frame34788 left-[516px] top-[76px] absolute justify-start items-start gap-[104px] inline-flex">
      <div className="Frame34785 flex-col justify-start items-start gap-3.5 inline-flex">
        <div className="Product text-center text-white text-[14px] font-medium leading-none">Product</div>
        <div className="Frame34783 flex-col justify-start items-start gap-2.5 flex">
          <div className="AnomalyDetection text-center text-zinc-400 text-[12px] font-medium leading-3">Anomaly Detection</div>
          <div className="ForecastingPlanning text-center text-zinc-400 text-[12px] font-medium leading-3">Forecasting & Planning</div>
          <div className="FraudSecurity text-center text-zinc-400 text-[12px] font-medium leading-3">Fraud & Security</div>
          <div className="MarketingSales text-center text-zinc-400 text-[12px] font-medium leading-3">Marketing & Sales</div>
          <div className="PredictiveModelling text-center text-zinc-400 text-[12px] font-medium leading-3">Predictive Modelling</div>
        </div>
      </div>
      <div className="Frame34784 flex-col justify-start items-start gap-3.5 inline-flex">
        <div className="Solutions text-center text-white text-[14px] font-medium leading-none">Solutions</div>
        <div className="Frame34783 flex-col justify-start items-start gap-2.5 flex">
          <div className="AnomalyDetection text-center text-zinc-400 text-[12px] font-medium leading-3">Anomaly Detection</div>
          <div className="ForecastingPlanning text-center text-zinc-400 text-[12px] font-medium leading-3">Forecasting & Planning</div>
          <div className="FraudSecurity text-center text-zinc-400 text-[12px] font-medium leading-3">Fraud & Security</div>
          <div className="MarketingSales text-center text-zinc-400 text-[12px] font-medium leading-3">Marketing & Sales</div>
          <div className="PredictiveModelling text-center text-zinc-400 text-[12px] font-medium leading-3">Predictive Modelling</div>
        </div>
      </div>
      <div className="Frame34786 flex-col justify-start items-start gap-3.5 inline-flex">
        <div className="Resources text-center text-white text-[14px] font-medium leading-none">Resources</div>
        <div className="Frame34783 flex-col justify-start items-start gap-2.5 flex">
          <div className="Blog text-center text-zinc-400 text-[12px] font-medium leading-3">Blog</div>
          <div className="Documentation text-center text-zinc-400 text-[12px] font-medium leading-3">Documentation</div>
          <div className="Events text-center text-zinc-400 text-[12px] font-medium leading-3">Events</div>
          <div className="ResourceLibrary text-center text-zinc-400 text-[12px] font-medium leading-3">Resource Library</div>
        </div>
      </div>
      <div className="Frame34787 flex-col justify-start items-start gap-3.5 inline-flex">
        <div className="Company text-center text-white text-[14px] font-medium leading-none">Company</div>
        <div className="Frame34783 flex-col justify-start items-start gap-2.5 flex">
          <div className="AboutUs text-center text-zinc-400 text-[12px] font-medium leading-3">About us</div>
          <div className="Contact text-center text-zinc-400 text-[12px] font-medium leading-3">Contact</div>
          <div className="Careers text-center text-zinc-400 text-[12px] font-medium leading-3">Careers</div>
          <div className="Press text-center text-zinc-400 text-[12px] font-medium leading-3">Press</div>
        </div>
      </div>
    </div>
  </div>
  <div className="Group8639 w-[296px] h-[309px] left-[1044px] top-[285px] absolute">
    <div className="Ellipse6 w-[296px] h-[309px] left-0 top-0 absolute bg-fuchsia-950 rounded-full" />
    <div className="CustomerSurveyAmico w-[247px] h-[249px] left-[24px] top-[30px] absolute">
      <div className="Questionary w-[82.76px] h-[188.96px] left-[31.77px] top-[31.81px] absolute">
      </div>
      <div className="SadFace w-[25.82px] h-[32.98px] left-[120.58px] top-[72.86px] absolute">
      </div>
      <div className="HappyFace w-[25.82px] h-[33px] left-[120.58px] top-[35.68px] absolute">
      </div>
      <div className="Chart w-[33.53px] h-[58.29px] left-[118.41px] top-[103.36px] absolute">
      </div>
      <div className="SpeachBubbles w-[55.06px] h-[142.39px] left-[156.96px] top-0 absolute">
        <div className="Stars w-[42.96px] h-[33.25px] left-[7.57px] top-[100.97px] absolute">
        </div>
        <div className="Stars w-[42.96px] h-[33.26px] left-[7.57px] top-[42.07px] absolute">
        </div>
      </div>
      <div className="Pencil w-[105.10px] h-[69.49px] left-[95.85px] top-[142.49px] absolute">
      </div>
    </div>
  </div>
  <div className="CheeseHalf15 w-[60.88px] h-[67.36px] left-[868px] top-[248px] absolute">
    <img className="Base w-[60.88px] h-[67.36px] left-0 top-0 absolute" src="https://via.placeholder.com/61x67" />
    <div className="Color w-[60.88px] h-[67.36px] left-0 top-0 absolute">
      <img className="Base w-[60.88px] h-[67.36px] left-0 top-0 absolute" src="https://via.placeholder.com/61x67" />
      <div className="GlobalColor w-[82.90px] h-[88.86px] left-[-11.01px] top-[-10.77px] absolute">
        <div className="Color w-[82.90px] h-[88.86px] left-0 top-0 absolute bg-gradient-to-r from-stone-950 to-black rounded-full" />
      </div>
    </div>
    <img className="Spec w-[60.88px] h-[67.36px] left-0 top-0 absolute" src="https://via.placeholder.com/61x67" />
  </div>
  <div className="CheeseHalf16 w-[60.88px] h-[58.57px] left-[1289.12px] top-[592.43px] absolute">
    <img className="Base w-[60.88px] h-[58.57px] left-0 top-0 absolute" src="https://via.placeholder.com/61x59" />
    <div className="Color w-[60.88px] h-[58.57px] left-0 top-0 absolute">
      <img className="Base w-[60.88px] h-[58.57px] left-0 top-0 absolute" src="https://via.placeholder.com/61x59" />
      <div className="GlobalColor w-[82.10px] h-[88px] left-[-10.61px] top-[-14.72px] absolute">
        <div className="Color w-[82.10px] h-[88px] left-0 top-0 absolute bg-gradient-to-r from-stone-950 to-black rounded-full" />
      </div>
    </div>
    <img className="Spec w-[60.88px] h-[58.57px] left-0 top-0 absolute" src="https://via.placeholder.com/61x59" />
  </div>
  <div className="Frame34801 w-[1440px] h-[100px] left-0 top-0 absolute bg-neutral-800">
    <div className="Frame34739 left-[432px] top-[34px] absolute justify-start items-start gap-4 inline-flex">
      <div className="Frame34738 p-2 justify-start items-start gap-2.5 flex">
        <div className="Solutions text-center text-[16px] font-medium leading-none">Solutions</div>
      </div>
      <div className="Frame34739 p-2 justify-start items-start gap-2.5 flex">
        <div className="Resources text-center text-white text-[16px] font-medium leading-none">Resources</div>
      </div>
      <div className="Frame34740 p-2 justify-start items-start gap-2.5 flex">
        <div className="Company text-center text-white text-[16px] font-medium leading-none">Company</div>
      </div>
    </div>
    <div className="Frame34743 left-[1070px] top-[23px] absolute justify-start items-center gap-6 inline-flex">
      <div className="LogIn text-white text-[16px] font-semibold">Log In</div>
      <div className="Frame34742 px-4 py-[18px] bg-gradient-to-r from-pink-400 to-indigo-500 rounded justify-start items-start gap-2.5 flex">
        <div className="RequestConsultation text-white text-[16px] font-semibold">Request Consultation</div>
      </div>
    </div>
    <div className="Logo left-[100px] top-[31px] absolute text-white text-[32px] font-medium">LOGO</div>
  </div>
  <div className="Frame34782 left-[100px] top-[285px] absolute flex-col justify-start items-start gap-[30px] inline-flex">
    <div className="Frame34771 flex-col justify-start items-start gap-[76px] flex">
      <div className="CostOptimization text-purple-500 text-[64px] font-normal">Cost optimization</div>
      <div className="WithAllTheValueOfServicesWhichWillBeOfferByOurAiInMarkettingAndSalesItWillHelpMaximizeBusinessValueReducesSourceOfWastefulSpendingUnderutilization w-[673px] h-[158px]"><span style="text-zinc-300 text-[22px] font-normal">With all the value of services which will be offer by our AI in marketting and sales, <br/></span><span style="text-zinc-300 text-[22px] font-normal"> It will help maximize business value, <br/>Reduces source of wasteful spending,<br/>Underutilization.</span></div>
    </div>
    <div className="Frame34743 px-4 py-[18px] bg-gradient-to-r from-pink-400 to-indigo-500 rounded justify-start items-start gap-2.5 inline-flex">
      <div className="RequestConsultation text-zinc-300 text-[16px] font-semibold">Request Consultation</div>
    </div>
  </div>
  <div className="Ellipse1 w-[100px] h-[100px] left-[1128px] top-[555px] absolute bg-gradient-to-r from-pink-400 to-indigo-500 rounded-full blur-[200px]" />
</div>
    </>
  );
}
